import React from 'react';
import { tablet, minWidth } from '../screenSizes';
import { smallMargin } from '../margins';

export const Html = ({ html, className }) => (
  <div
    css={`
      text-align: center;
      line-height: 2;

      ${minWidth(tablet)} {
        width: 80%;
        margin: 0 auto;
      }

      & p:not(:last-child) {
        margin-bottom: ${smallMargin};
      }

      ${className};
    `}
    dangerouslySetInnerHTML={{ __html: html }}
  />
);



// WEBPACK FOOTER //
// ./app/components/Html.js